import { Space } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { EmailConfig, EmailConfigBase } from 'api/account';
import { LinkButton } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Modal } from 'components/atoms/modal';
import { SettingsLabel } from 'components/organisms/module-settings/styles';
import { useTranslation } from 'hooks/use-translation';
import styles from './input.module.css';

const welcome = 'welcome';
const notifications = 'notifications';

export const EmailConfigs: FC<{
  config: Omit<EmailConfig, 'spf' | 'dkim1' | 'dkim2'>;
  onUpdate: (data: EmailConfigBase) => void;
  loading: boolean;
}> = ({ config, loading = false, onUpdate }) => {
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState<boolean>(false);

  const invitationEmailLabel = useTranslation(
    'settings.email_configuration.invitation.label',
  );
  const invitationEmailExtra = useTranslation(
    'settings.email_configuration.invitation.extra',
  );
  const notificationEmailLabel = useTranslation(
    'settings.email_configuration.notifications.label',
  );
  const okText = useTranslation('save');

  return (
    <>
      <Space direction="vertical" size="small">
        <SettingsLabel>
          <FormattedMessage id="configure_emails" />
        </SettingsLabel>

        <FormattedMessage
          id="settings.email_configuration.invitation.text"
          values={{
            b: () => (
              <b>
                {config?.invitationPrefix || welcome}@{config?.emailDomain}
              </b>
            ),
          }}
        />
        <FormattedMessage
          id="settings.email_configuration.notification.text"
          values={{
            b: () => (
              <b>
                {config?.notificationPrefix || notifications}@
                {config?.emailDomain}
              </b>
            ),
          }}
        />
        <LinkButton onClick={() => setShowModal(true)}>
          <FormattedMessage id="edit_emails" />
          ...
        </LinkButton>
      </Space>

      {/* Modal */}
      <Modal
        visible={showModal}
        title={<FormattedMessage id="custom_emails" />}
        onCancel={() => setShowModal(false)}
        okText={okText}
        okButtonProps={{ loading }}
        onOk={() => {
          form.validateFields().then((values) => {
            setShowModal(false);
            onUpdate(values);
          });
        }}
        destroyOnClose
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={config}
          preserve={false}
        >
          <Form.Item name="emailDomain" hidden />
          <Form.Item
            name="invitationPrefix"
            label={invitationEmailLabel}
            extra={invitationEmailExtra}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              className={styles.inputGroup}
              type="text"
              suffix={`@${config?.emailDomain}`}
            />
          </Form.Item>
          <Form.Item
            name="notificationPrefix"
            label={notificationEmailLabel}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              className={styles.inputGroup}
              type="text"
              suffix={`@${config?.emailDomain}`}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
